import _ from "lodash";
import {
  CrudFilter,
  HttpError,
  LogicalFilter,
  useDataProvider,
} from "@refinedev/core";
import { useTable } from "@refinedev/react-table";
import { useOrdersColumns } from "@/pages/orders/hooks/use-columns";
import { IOrderData } from "@/types/order";
import { ListView } from "@/components/refine-ui/views/list-view";
import { DataTableActionBar } from "@/components/refine-ui/data-table/data-table-action-bar";
import { DataTable } from "@/components/refine-ui/data-table/data-table";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import moment from "moment";
import { transformFilter } from "@/lib/refineUtils";

export const OrdersList = () => {
  const columns = useOrdersColumns();
  const { custom } = useDataProvider()();

  const table = useTable<IOrderData, HttpError>({
    columns,
    columnResizeMode: "onChange",
    initialState: {
      columnPinning: {
        right: ["actions"],
      },
    },
    refineCoreProps: {
      meta: {
        defaultQueryBy: "status, botStatus",
        facetBy: ["status", "botStatus"],
      },
      sorters: {
        initial: [
          {
            field: "createdAt",
            order: "desc",
          },
        ],
      },
      pagination: {
        pageSize: 25,
      },
    },
    meta: {
      querySuggestions: [
        {
          id: "metadata.event.name",
          label: "event",
        },
        {
          id: "params.email",
          label: "email",
        },
        {
          id: "confirmationNumber",
          label: "confirmation no.",
        },
        {
          id: "ticketing.provider",
          label: "provider",
        },
      ],
    },
  });

  return (
    <ListView>
      <DataTableActionBar resource="orders" table={table}>
        <div className="flex items-center space-x-2">
          <Checkbox
            id="terms2"
            onCheckedChange={(value) => {
              let filters: CrudFilter[] = [];
              if (value) {
                filters = [
                  {
                    field: "botStatus",
                    operator: "in",
                    value: "PurchaseError",
                  },
                ];
              } else {
                filters = [];
              }
              table?.refineCore.setFilters((prev) => {
                return [
                  ...prev.filter(
                    (f) =>
                      f.operator !== "in" &&
                      (f as LogicalFilter).field !== "botStatus",
                  ),
                  ...filters,
                ];
              });
            }}
          />
          <label
            htmlFor="terms2"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Need action
          </label>
        </div>
        <Button
          variant={"ghost"}
          size={"sm"}
          onClick={async () => {
            let filters = table.refineCore.filters
              ?.map(transformFilter)
              .filter((f) => f);

            if (!_.isEmpty(table.reactTable.getState().globalFilter))
              filters.push(table.reactTable.getState().globalFilter);

            console.debug(
              "EXPORT FILTERS",
              table.refineCore.filters,
              table.reactTable.getState().globalFilter,
              filters,
            );

            const response = await custom?.({
              url: "",
              method: "get",
              query: {
                filters: filters.join(" && "),
              },
              meta: { urlPath: "orders/export", responseType: "blob" },
            });
            if (response?.data && response.data instanceof Blob) {
              var csvURL = window.URL.createObjectURL(response!.data);
              var tempLink = document.createElement("a");
              tempLink.href = csvURL;
              tempLink.setAttribute(
                "download",
                `${moment().format("YYYYMMDD")}_orders`,
              );
              tempLink.click();
            }
          }}
          className="text-foreground items-center space-x-1"
        >
          Export
        </Button>
      </DataTableActionBar>
      <DataTable table={table} />
    </ListView>
  );
};
